/* import __COLOCATED_TEMPLATE__ from './node.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import type Node from '../../models/graph-editor/node';
import { type SafeString } from 'handlebars';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
interface Args {
  node: Node;
}
export default class GraphEditorNodeComponent extends Component<Args> {
  get style(): SafeString {
    return sanitizeHtml(`
      --x: ${this.args.node.position.x}px;
      --y: ${this.args.node.position.y}px;
    `);
  }
}
